import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "../theme/theme";
import { BrowserRouter } from "react-router-dom";

export default function AppProviders({ children }) {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          {children}
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}